import React, { useContext, useEffect, useState } from 'react';
import { StudentContext } from '../contexts/StudentContext';

import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const Profile = () => {
  const { studentData } = useContext(StudentContext);
  const [courseInfo, setCourseInfo] = useState(null);
  const [courseLoading, setCourseLoading] = useState(false);
  const [courseError, setCourseError] = useState(null);

  useEffect(() => {
    const fetchCourse = async () => {
      if (studentData && studentData.course) {
        setCourseLoading(true);
        setCourseError(null);
        try {
          const courseRef = doc(db, 'courses', studentData.course);
          const courseSnap = await getDoc(courseRef);
          if (courseSnap.exists()) {
            setCourseInfo(courseSnap.data());
          } else {
            setCourseInfo(null);
            setCourseError('Course not found');
          }
        } catch (err) {
          setCourseError('Error fetching course');
          setCourseInfo(null);
        }
        setCourseLoading(false);
      }
    };
    fetchCourse();
  }, [studentData]);

  if (studentData === undefined) {
    return <LoadingState message="Loading..." />;
  }

  if (!studentData) {
    return <LoadingState message="No profile data found." />;
  }
  //console.log(studentData);
  const { name, email, phone, city, location, dob, college, educationCourse, } = studentData;
  return (
    <div className="profile-page" style={{ padding: '2rem', backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <h2 className="mb-4" style={{ color: '#4f46e5', fontWeight: 'bold' }}>My Profile</h2>
        <div className="card mb-4 shadow-sm">
          <div className="card-body d-flex align-items-center">
            <div className="profile-image rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: 100, height: 100, fontSize: 40 }}>
              {name ? name.split(' ').map(n => n[0]).join('').toUpperCase() : '?'}
            </div>
            <div className="ms-3">
              <h4 className="mb-0" style={{ fontWeight: 'bold' }}>{name || 'No Name'}</h4>
              <p className="text-muted mb-0">{city || location}</p>
            </div>
          </div>
        </div>
        <div className="card mb-4 shadow-sm">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0" style={{ fontWeight: 'bold' }}>Personal Information</h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>First Name:</strong> {name.split(' ')[0]}</p>
                <p><strong>Email address:</strong> {email}</p>
                <p><strong>College:</strong> {college !== "none" ? college : "Not Available"}</p>
                <p><strong>Date of Birth:</strong> {dob}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Last Name:</strong> {name.split(' ')[1]}</p>
                <p><strong>Phone:</strong> {phone}</p>
                <p><strong>Education Course:</strong> {educationCourse}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="card shadow-sm">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0" style={{ fontWeight: 'bold' }}>Course Information</h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <p><strong>Course:</strong> {courseInfo?.title || 'Not Available'}</p>
                <p><strong>Duration:</strong> {courseInfo?.duration || 'Not Available'}</p>
                <p><strong>Description:</strong> {courseInfo?.description || 'Not Available'}</p>
              </div>
              <div className="col-md-6">
                <p><strong>Category:</strong> {courseInfo?.category || 'Not Available'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LoadingState = ({ message }) => (
  <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
    <h4>{message}</h4>
  </div>
);

export default Profile;